<template>
    <div
        ref="privilege-card"
        :class="['privilege-card', vipInfo.vipStatusName, status]"
        @mouseenter="handleMouseEnter"
    >
        <div
            :class="['icon', isNoHas ? 'no-icon' : '']"
            :style="{backgroundImage: 'url(' + showConfig.icon + ')'}"
        ></div>
        <div class="title">
            {{ privilegeInfo.title }}
        </div>
        <div class="subTitle">{{ privilegeInfo.subTitle }}</div>
        <div class="button" @click="handleButtonClick">
            {{ showConfig.buttonText }}
        </div>
        <veui-popover
            v-if="privilegeInfo.help"
            :open.sync="isHelpShow"
            ui="m"
            target="privilege-card"
            position="right"
            overlay-class="help-popover"
        >
            <div class="help-content">
                <div
                    class="image"
                    :style="{
                        backgroundImage:
                            'url(' + (privilegeInfo.help.image) + ')',
                    }"
                ></div>
                <div class="title">
                    {{ isActiveHelp ? "权益激活成功!" : ""
                    }}{{ privilegeInfo.help.title }}
                </div>
                <div class="subTitle">{{ privilegeInfo.help.subTitle }}</div>
            </div>
        </veui-popover>
    </div>
</template>

<script>
/**
 * @desc 权益卡片
 * @author <xingminghua@baidu.com>
 */
import {Popover} from 'veui';
import mixinauthentice from '@/mixins/authentice';
import {pageChange} from '@/utils/util';
// 权益卡片状态枚举
const STATUS_ENUM = {
    NOACTIVE: 'noactive', // 未激活，点击激活
    CANUSE: 'canuse', // 已激活，有跳转链接可以去使用
    CANSCAN: 'canscan' // 已激活，没有链接，能查看效果
};

export default {
    mixins: [mixinauthentice],
    components: {
        'veui-popover': Popover
    },
    props: {
        privilegeInfo: {
            type: Object,
            default: () => {}
        },
        isNoHas: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isSubmitting: false,
            isHelpShow: false,
            isActiveHelp: false
        };
    },
    watch: {
        isHelpShow(val) {
            if (!val) {
                this.isActiveHelp = false;
            }
        }
    },
    computed: {
        status() {
            if (this.privilegeInfo.link) {
                return STATUS_ENUM.CANUSE;
            }
            if (!this.privilegeInfo.help) {
                return STATUS_ENUM.NOACTIVE;
            }
            return STATUS_ENUM.CANSCAN;
        },
        showConfig() {
            let {privilegeInfo = {}} = this;
            let {icon} = privilegeInfo;
            let result = {
                icon: icon,
                buttonText: ''
            };
            switch (this.status) {
                case STATUS_ENUM.NOACTIVE:
                    result.buttonText = '激活权益';
                    break;
                case STATUS_ENUM.CANUSE:
                    result.buttonText = '立即使用';
                    break;
                case STATUS_ENUM.CANSCAN:
                    result.buttonText = '查看效果';
                    break;
                default:
                    break;
            }
            return result;
        }
    },
    methods: {
        handleButtonClick() {
            this.$wywLog.send({
                serverId: 16844,
                area: this.privilegeInfo.logName || this.privilegeInfo.name,
                action: 'click',
                status: this.status
            });
            // 除线索认领外，其他权益的使用和激活均需要检查个人信息审核
            const needCheckAuthentice = this.privilegeInfo.name !== 'lawclues';
            switch (this.status) {
                case STATUS_ENUM.NOACTIVE:
                    (!needCheckAuthentice || this.checkAuthentice())
                        && this.activePrivilege();
                    break;
                case STATUS_ENUM.CANUSE:
                    (!needCheckAuthentice || this.checkAuthentice())
                        && this.goLink();
                    break;
                case STATUS_ENUM.CANSCAN:
                    (!needCheckAuthentice || this.checkAuthentice())
                        && this.openHelpModal();
                    break;
                default:
                    break;
            }
        },
        // 激活权益
        activePrivilege() {
            if (this.isSubmitting) {
                return;
            }
            this.isSubmitting = true;
            this.$http
                .post('/bp/api/user/privilege/activate', {
                    info: this.privilegeInfo.name
                })
                .then(res => {
                    if (+res?.code === 0) {
                        this.openHelpModal('active');
                        this.privilegeInfo.isActive = true;
                    }
                    else {
                        this.$normalizeResponseError(res);
                    }
                })
                .finally(() => (this.isSubmitting = false));
        },
        // 前往链接使用权益
        goLink() {
            const {link} = this.privilegeInfo;
            if (!link) {
                return;
            }
            pageChange({url: link});
        },
        // 查看权益效果
        openHelpModal(type) {
            if (!this.privilegeInfo.help) {
                return;
            }
            if (type === 'active') {
                this.isActiveHelp = true;
            }
            this.isHelpShow = true;
        },
        handleMouseEnter() {
            this.isHelpShow = true;
        }
    }
};
</script>
<style lang="less" scoped>

.privilege-card {
    position: relative;
    align-self: stretch;
    width: 197px;
    height: 232px;
    padding: 40px 12px 20px;
    border: 1px solid #e0ebff;
    background-image: linear-gradient(44deg, #f7faff 0%, #f3f7ff 100%);
    border-radius: 8px;
    display: flex;
    align-items: center;
    flex-direction: column;

    &:hover {
        background-image: linear-gradient(44deg, #f7faff 0%, #e8f1ff 100%);
        border: 2px solid rgba(184, 208, 255, .7);

        .icon {
            transform: translateY(-20px);
        }

        .title {
            transform: translateY(-26px);
        }

        .subTitle {
            transform: translateY(-30px);
        }

        .button {
            display: block;
        }
    }

    .icon {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background-size: cover;
        background-position: center;
    }

    .no-icon {
        opacity: .4;
    }

    .title {
        display: flex;
        align-items: center;
        margin-top: 20px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #333;
        line-height: 16px;
        font-weight: 500;

        .help-icon {
            width: 14px;
            height: 14px;
            margin-left: 3px;
            cursor: pointer;
        }
    }

    .subTitle {
        margin-top: 12px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #848691;
        letter-spacing: 0;
        text-align: center;
        line-height: 22px;
        font-weight: 400;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .button {
        cursor: pointer;
        position: absolute;
        display: none;
        bottom: 20px;
        width: 166px;
        height: 36px;
        background: #fff;
        border-radius: 4px;
        text-align: center;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #fff;
        background-color: #05f;
        letter-spacing: 0;
        line-height: 16px;
        font-weight: 500;
        padding: 10px 16px;

        &:hover {
            opacity: .8;
        }
    }
}

.vip,
.freeVip {
    background-image: linear-gradient(44deg, #fffbf7 0%, #fff9f3 100%);

    &.privilege-card {
        border: 1px solid #ffe6d1;

        &:hover {
            background-image: linear-gradient(44deg, #fffaf5 0%, #fff7f0 100%) !important;
            border: 2px solid #ffe2ca;
        }
    }

    .button {
        color: #401611;
        background-color: #fed9b9;
    }
}

.help-popover.veui-tooltip-box[x-placement=right] {
    left: -232px !important;
}

.help-popover.veui-tooltip-box[x-placement=left] {
    left: 232px !important;
}

.help-popover {
    /deep/ .veui-tooltip {
        margin: 0;
        background: #fff;
        border: 1px solid #ebeff6;
        box-shadow: 0 12px 40px 0 rgba(97, 98, 104, .1);
        border-radius: 8px;

        .veui-tooltip-content {
            margin: 20px;
        }

        .veui-tooltip-arrow {
            display: none;
        }
    }

    .help-content {
        width: 220px;

        .image {
            width: 220px;
            height: 153px;
            border-radius: 8px;
            background-size: cover;
            background-position: center;
        }

        .title {
            margin-top: 14px;
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #333;
            line-height: 24px;
            font-weight: 600;
        }

        .subTitle {
            margin-top: 14px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #7a7a7a;
            line-height: 22px;
            font-weight: 400;
        }

        .button {
            cursor: pointer;
            margin-top: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 220px;
            height: 40px;
            background-image: linear-gradient(136deg, #0086ff 0%, #05f 100%);
            border-radius: 5px;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #fff;
            text-align: center;
            line-height: 14px;
            font-weight: 500;
        }
    }
}
</style>
